/* TODO: should most of this go away in favor of more specific calendar styles? */
.calendar {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  column-gap: 10px;
  row-gap: 15px;

  .month {
    margin: 5px;
    border-collapse: collapse;
  }
  .day, .month_row, .weekday {
    background-color: #eee;
    border: 1px solid black;
    user-select: none;
  }
  .month_row {
    /* todo vars for these sizes */
    height: 30px;
    text-align: center;
  }
  .month_row {
    color: #444;
  }

  .weekday,
  .day {
    width: 60px;
    font-size: x-small;
  }
  .day {
    height: 60px;
    vertical-align: top;
    text-align: right;
    color: #848484;
  }

  /* todo: move these */
  .count {
    font-size: large;
    text-align: center;
    /* padding-top: 4px; */
    cursor: pointer;
    /* override the <a> defaults */
    display: block;
    text-decoration: none;
  }
  .count:hover {
    text-decoration: underline;
  }
}
